// Forgot Password Page
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setIsLoading(true);
    
    try {
      const response = await fetch(`${API}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        setSubmitted(true);
        setMessage(data.message);
      } else {
        setError(data.detail || 'Une erreur est survenue');
      }
    } catch (err) {
      setError('Erreur de connexion. Veuillez réessayer.');
    } finally {
      setIsLoading(false);
    }
  };

  const inputStyle = {
    width: '100%',
    padding: '12px 16px',
    fontSize: '0.9375rem',
    fontFamily: 'var(--font-corps)',
    border: '1.5px solid #E2E6EA',
    borderRadius: '10px',
    outline: 'none',
    transition: 'all 200ms ease',
    boxSizing: 'border-box',
    color: '#191D1E',
    background: '#FAFBFC'
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#191D1E',
      fontFamily: 'var(--font-corps)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <div style={{
        position: 'absolute',
        top: '-20%',
        right: '-10%',
        width: '600px',
        height: '600px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(57,125,255,0.08) 0%, transparent 70%)',
        pointerEvents: 'none'
      }} />

      <div style={{
        background: '#FFFFFF',
        borderRadius: '16px',
        boxShadow: '0 24px 64px rgba(0, 0, 0, 0.2)',
        padding: '48px 40px',
        width: '100%',
        maxWidth: '420px',
        position: 'relative',
        animation: 'fadeInUp 0.5s ease-out'
      }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <img 
            src={`${BACKEND_URL}/api/static/logos/pde-logo-horizontal.png`}
            alt="Place des Énergies"
            style={{ height: '40px', width: 'auto', marginBottom: '20px' }}
            onError={(e) => { e.target.style.display = 'none'; }}
          />
          <p style={{
            fontFamily: 'var(--font-corps)',
            fontSize: '0.9375rem',
            color: '#687175',
            margin: 0
          }}>
            Réinitialisation du mot de passe
          </p>
        </div>

        {submitted ? (
          <div style={{ textAlign: 'center', animation: 'fadeIn 0.4s ease-out' }}>
            <div style={{
              width: '56px',
              height: '56px',
              background: '#ECFDF5',
              borderRadius: '14px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 20px'
            }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#10D183" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 2L11 13"/><path d="M22 2L15 22L11 13L2 9L22 2Z"/></svg>
            </div>
            <p style={{
              color: '#191D1E',
              fontSize: '0.9375rem',
              marginBottom: '8px',
              fontWeight: '500',
              fontFamily: 'var(--font-titre)'
            }}>
              Email envoyé
            </p>
            <p style={{
              color: '#687175',
              fontSize: '0.875rem',
              marginBottom: '28px',
              lineHeight: '1.6'
            }}>
              {message || 'Vérifiez votre boîte de réception et vos spams.'}
            </p>
            <Link
              to="/login"
              style={{
                display: 'inline-block',
                padding: '12px 32px',
                backgroundColor: '#397DFF',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '10px',
                fontWeight: '500',
                fontSize: '0.875rem',
                fontFamily: 'var(--font-corps)',
                boxShadow: '0 2px 8px rgba(57,125,255,0.25)',
                transition: 'all 200ms ease'
              }}
            >
              Retour à la connexion
            </Link>
          </div>
        ) : (
          <>
            <p style={{
              color: '#687175',
              fontSize: '0.875rem',
              marginBottom: '24px',
              textAlign: 'center',
              lineHeight: '1.6'
            }}>
              Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.
            </p>

            {error && (
              <div style={{
                background: '#FEF2F2',
                border: '1px solid #FECACA',
                borderRadius: '10px',
                padding: '12px 16px',
                marginBottom: '20px',
                color: '#DC2626',
                fontSize: '0.875rem',
                animation: 'slideDown 0.3s ease-out'
              }}>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '20px' }}>
                <label style={{
                  display: 'block',
                  fontSize: '0.8125rem',
                  fontWeight: '500',
                  color: '#3C4649',
                  marginBottom: '8px'
                }}>
                  Adresse email
                </label>
                <input
                  type="email"
                  placeholder="nom@entreprise.fr"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  style={inputStyle}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#397DFF';
                    e.target.style.boxShadow = '0 0 0 3px rgba(57,125,255,0.1)';
                    e.target.style.background = '#FFFFFF';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#E2E6EA';
                    e.target.style.boxShadow = 'none';
                    e.target.style.background = '#FAFBFC';
                  }}
                />
              </div>

              <button
                type="submit"
                disabled={isLoading}
                style={{
                  width: '100%',
                  padding: '13px',
                  fontSize: '0.9375rem',
                  fontWeight: '500',
                  fontFamily: 'var(--font-corps)',
                  color: '#FFFFFF',
                  backgroundColor: isLoading ? '#7BABFF' : '#397DFF',
                  border: 'none',
                  borderRadius: '10px',
                  cursor: isLoading ? 'not-allowed' : 'pointer',
                  transition: 'all 200ms ease',
                  boxSizing: 'border-box',
                  boxShadow: isLoading ? 'none' : '0 2px 8px rgba(57,125,255,0.25)',
                  marginBottom: '16px'
                }}
                onMouseEnter={(e) => {
                  if (!isLoading) {
                    e.target.style.backgroundColor = '#2B6AE6';
                    e.target.style.boxShadow = '0 4px 16px rgba(57,125,255,0.35)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isLoading) {
                    e.target.style.backgroundColor = '#397DFF';
                    e.target.style.boxShadow = '0 2px 8px rgba(57,125,255,0.25)';
                  }
                }}
              >
                {isLoading ? 'Envoi en cours...' : 'Envoyer le lien'}
              </button>
            </form>

            <div style={{ textAlign: 'center' }}>
              <Link
                to="/login"
                style={{
                  fontSize: '0.8125rem',
                  color: '#687175',
                  textDecoration: 'none',
                  fontFamily: 'var(--font-corps)',
                  transition: 'color 200ms ease'
                }}
                onMouseEnter={(e) => e.target.style.color = '#397DFF'}
                onMouseLeave={(e) => e.target.style.color = '#687175'}
              >
                ← Retour à la connexion
              </Link>
            </div>
          </>
        )}

        {/* Footer */}
        <div style={{
          marginTop: '32px',
          paddingTop: '20px',
          borderTop: '1px solid #EEF0F3',
          textAlign: 'center',
          fontSize: '0.75rem',
          color: '#939BA0',
          fontFamily: 'var(--font-corps)'
        }}>
          Place des Énergies © {new Date().getFullYear()}
        </div>
      </div>
    </div>
  );
}
